import {
  userInfoLoginApi,
  codeLoginApi,
  updateUserinfoAPi,
  updateUserPaddwordApi,
  getMyUserinfoApi,
  userEmailLoginApi,
  bindUserEmailApi,
} from "@/apis/userInfo";
import { setToken, removeToken } from "@/utils/auth";
import { Message } from "element-ui";
import router from "@/router";
const state = {
  moduleFlag: false,
  loading: false, // app组件
  loadingText: "加载中",
  mainLoading: false, // user组件
  userInfo: JSON.parse(localStorage.getItem("userInfo")) || {},
  versionFlag: false,
  versionInfo: JSON.parse(localStorage.getItem("versionInfo")) || {},
};

const mutations = {
  SET_MODULE_FLAG(state, flag) {
    // 是否显示登录框
    state.moduleFlag = flag;
  },
  SET_VERSION_FLAG(state, flag) {
    console.log(state, flag, "dddddddddddddd");
    state.versionFlag = flag;
  },
  SET_VERSION_INFO(state, versionInfo) {
    state.versionInfo = versionInfo;
    localStorage.setItem("versionInfo", JSON.stringify(versionInfo));
  },
  SET_USER_INFO(state, userInfo) {
    // 设置用户账号信息
    state.userInfo = userInfo;
    localStorage.setItem("userInfo", JSON.stringify(userInfo));
  },
  SET_LOADING(state, flag) {
    // 设置APP页面的loading
    state.loading = flag;
  },
  SET_MAIN_LOADING(state, flag) {
    state.mainLoading = flag;
  },
  SET_LOADING_TEXT(state, text) {
    // 设置APP页面的loadingText
    state.loadingText = text;
  },
  LOGIN_OUT(state) {
    // 退出登录
    state.userInfo = {};
    state.moduleFlag = true;
    removeToken();
    localStorage.removeItem("userInfo");
    if (router.currentRoute.path !== "/") {
      router.replace("/");
    }
    Message({ type: "error", message: "已退出登录！" });
  },
};

const actions = {
  async login({ commit }, loginForm) {
    console.log(loginForm,"loginform")
    const obj = {
      username: loginForm.phone,
      password: loginForm.loginPassword
    }
    // 登录 --密码登录
    commit("SET_LOADING_TEXT", "登陆中...");
    const res1 = await userInfoLoginApi(obj);
    if (res1 && res1.message == "success") {
      setToken(res1.result.token);
      Message({ type: "success", message: "登录成功！" });
      commit("SET_MODULE_FLAG", false);
      commit("SET_USER_INFO", res1.result.student);

      // const res = await getMyUserinfoApi();
      // if (res && res.message == "success") {
      //   commit("SET_USER_INFO", res.result);
      // }
    }
  },
  async codeLogin({ commit }, loginForm) {
    // 登录 --验证码登录
    const res1 = await codeLoginApi({
      username: loginForm.phone,
      password: loginForm.verifyCode,
    });
    if (res1 && res1.message == "success") {
      setToken(res1.result.token);
      Message({ type: "success", message: "登录成功！" });
      commit("SET_MODULE_FLAG", false);
      commit("SET_USER_INFO", res1.result.student);
      // const res = await getMyUserinfoApi();
      // if (res && res.message == "success") {
      //   commit("SET_USER_INFO", res.result);
      //   // const oldVersion = 1.8;
      //   // const res2 = await getNewVersionApi();
      //   // const newVersion = res2.result;
      //   // if (oldVersion < newVersion.version) {
      //   //   state.versionFlag = true
      //   //   commit("SET_VERSION_FLAG", true);
      //   //   commit('SET_VERSION_INFO', newVersion)
      //   //   console.log('我走到这里了', newVersion, state.versionFlag)
      //   // }
      // }
    }
  },
  async setUserMes({ dispatch }, payload) {
    const key = payload[0];
    const val = payload[1];
    const res = await updateUserinfoAPi({
      [key]: val,
    });
    if (res && res.message == "success") {
      Message({ type: "success", message: "修改成功！" });
      dispatch("updateUserInfo");
    }
  },
  async updateUserInfo({ commit }) {
    const res = await getMyUserinfoApi();
    if (res && res.message == "success") {
      commit("SET_USER_INFO", res.result);
    }
  },
  async changePassword({ commit }, form) {
    const res = await updateUserPaddwordApi(form);
    if (res && res.message == "success") {
      Message({ type: "success", message: "修改成功！" });
      setTimeout(() => commit("LOGIN_OUT"), 1500);
    }
  },
  async emailLogin({ commit }, loginForm) {
    // 登录 --邮箱登录
    commit("SET_LOADING_TEXT", "登陆中...");
    const res1 = await userEmailLoginApi(loginForm);
    if (res1 && res1.message == "success") {
      setToken(res1.result.token);
      Message({ type: "success", message: "登录成功！" });
      commit("SET_MODULE_FLAG", false);
      const res = await getMyUserinfoApi();
      if (res && res.message == "success") {
        commit("SET_USER_INFO", res.result);
      }
    }
  },
  async bindEmail({ commit }, loginForm) {
    // 登录 --邮箱登录
    commit("SET_LOADING_TEXT", "绑定中...");
    const res1 = await bindUserEmailApi(loginForm);
    if (res1 && res1.message == "success") {
      Message({ type: "success", message: "绑定成功！" });
      const res = await getMyUserinfoApi();
      if (res && res.message == "success") {
        commit("SET_USER_INFO", res.result);
      }
    }
  },
};

export default {
  state,
  mutations,
  actions,
  namespaced: true,
};
